export default __webpack_public_path__ + "img/bSofocue.b7f2c983.svg";